import React, { ReactElement } from 'react';

// Hooks
import {
    useActiveTiptapEditorCallback,
    useTiptapActiveEditorSelector,
} from '../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

// Utils
import { isListTypeClosestActive } from '../../../../../../common/tiptap/extensions/list/tiptapListUtils';

// Components
import RichTextTool from '../richContentTools/RichTextTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';
import { TiptapNodeType } from '../../../../../../common/tiptap/tiptapTypes';

interface TiptapIndentControlProps extends ToolbarToolProps {
    command: 'sinkListItem' | 'liftListItem';
}

const TiptapTextIndentControlTool = ({ command, ...props }: TiptapIndentControlProps): ReactElement => {
    const isOrderListActive = useTiptapActiveEditorSelector(isListTypeClosestActive(TiptapNodeType.orderedList));
    const isBulletListActive = useTiptapActiveEditorSelector(isListTypeClosestActive(TiptapNodeType.bulletList));

    const isListActive = isOrderListActive || isBulletListActive;

    // Check if the operation is actually possible
    const canExecute = useTiptapActiveEditorSelector((editor) => {
        if (!editor || !isListActive) return false;

        // Check if the editor can sink/lift the list item
        // this is a way to check if the operation is possible
        return editor.can()?.[command]?.('listItem') || false;
    });

    const handleClick = useActiveTiptapEditorCallback((editor) => {
        if (!editor) return;
        return editor.commands?.[command]?.('listItem');
    });

    return <RichTextTool onClick={handleClick} iconName={props.iconName} disabled={!canExecute} {...props} />;
};

export default TiptapTextIndentControlTool;
